/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react"
import { CircularProgress } from "@material-ui/core"
import { putRequest, getRequest } from "utils/request"
import { toast } from "react-toastify"

import { i18n } from "../../translate/i18n"

import "./style.css"
import { useAuth } from "hooks/auth"
import { useModal } from "hooks/modal"

export default function ChangePassword({ match, history }) {
  const [loading, setLoading] = useState(false)
  const [password, setPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [confirmpassword, setConfirmPassword] = useState("")
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [userid, setUserId] = useState(null)
  const [user, setUser] = useState("")
  const { toggleHelperId } = useModal()

  const {
    userIdChangePassword,
    setUserIdChangePassword,
    changePassword,
    setChangePassword,
  } = useAuth()

  const loadUser = async () => {
    const ReturnGet = await getRequest(`/users/${userIdChangePassword}`)
    if (ReturnGet.success) {
      setUser(ReturnGet.data)
    }
  }

  const handleConfirm = async () => {
    setLoading(true)
    // const user = localStorage.getItem("user-omni");
    // const CompleteUser = JSON.parse(user);
    if (password === confirmpassword) {
      //MUDAR SENHA
      await putRequest(
        `/users/staff/changepassword/${userid ? userid : userIdChangePassword}`,
        {
          password: password,
        }
      )
      if (userIdChangePassword) {
        history.push(`/dashboard/newuser/${Number(userIdChangePassword)}`)
        setUserIdChangePassword(null)
      } else {
        history.push("/dashboard")
      }
    } else {
      toast.error("Senhas não coincidem !")
    }
    setLoading(false)
  }

  useEffect(() => {
    if (changePassword) {
      setUserId(userIdChangePassword)
      loadUser()
      setChangePassword(false)
    } else {
      const data = JSON.parse(sessionStorage.getItem("@Omni:user"))
      setUserId(data.id)
    }
    toggleHelperId(2)
  }, [])

  return (
    <div className="col-12" style={{ overflowY: "auto" }}>
      <div className="container-card">
        {!loading ? (
          <>
            <form
              className="form-edit"
              onSubmit={(e) => {
                e.preventDefault()
                handleConfirm()
              }}
            >
              <h4 className="header-title">{i18n.t("changePassword")}</h4>
              {user && (
                <h5 className="header-title">{`Usuário: ${user.name}`}</h5>
              )}
              <div className="form-row">
                <div className="form-group col-md-3">
                  <label>{i18n.t("password2")}</label>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    autocomplete="off"
                    placeholder={i18n.t("password2")}
                    required
                    value={password}
                    onChange={(value) => setPassword(value.target.value)}
                  />
                  <i
                    className={showPassword ? "fas fa-eye-slash" : "fas fa-eye"}
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      top: 35,
                      right: 15,
                      cursor: "pointer",
                    }}
                  ></i>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group col-md-3">
                  <label>{i18n.t("confirmPassword")} *</label>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control"
                    autocomplete="off"
                    placeholder={i18n.t("confirmPassword")}
                    required
                    value={confirmpassword}
                    onChange={(value) => setConfirmPassword(value.target.value)}
                  />
                  <i
                    className={
                      showConfirmPassword ? "fas fa-eye-slash" : "fas fa-eye"
                    }
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={{
                      position: "absolute",
                      top: 35,
                      right: 15,
                      cursor: "pointer",
                    }}
                  ></i>
                </div>
              </div>
              <div
                className="button-list mt-3 pull-right"
                style={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  marginRight: 30,
                  marginBottom: 5,
                }}
              >
                {userid && (
                  <button
                    type="button"
                    className="btn btn-outline-danger"
                    onClick={() => history.goBack()}
                  >
                    <i i className="mdi mdi-backup-restore"></i>
                    {i18n.t("getBack")}
                  </button>
                )}
                <button type="submit" className="btn btn-outline-success">
                  <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                  {i18n.t("save")}
                </button>
              </div>
            </form>
          </>
        ) : (
          <div className="area-loading">
            <CircularProgress />
          </div>
        )}
      </div>
    </div>
  )
}
